"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var useTabs = function useTabs(tabs, setActiveKey) {
  var _useState = (0, _react.useState)(tabs[0].component),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      activeTabPanel = _useState2[0],
      setActiveTabPanel = _useState2[1];

  var handleTabChange = (0, _react.useCallback)(function (key) {
    var tabObj = tabs.find(function (tab) {
      return tab.key === key;
    });

    if (tabObj) {
      setActiveTabPanel(tabObj.component);
    } // For changing activeKey


    if (typeof setActiveKey === 'function') {
      setActiveKey(key);
    }
  }, [setActiveKey, tabs]);
  return [activeTabPanel, handleTabChange];
};

var _default = useTabs;
exports["default"] = _default;
//# sourceMappingURL=useTabs.js.map